// Imports
import ___CSS_LOADER_API_SOURCEMAP_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/sourceMaps.js";
import ___CSS_LOADER_API_IMPORT___ from "../../../node_modules/css-loader/dist/runtime/api.js";
var ___CSS_LOADER_EXPORT___ = ___CSS_LOADER_API_IMPORT___(___CSS_LOADER_API_SOURCEMAP_IMPORT___);
// Module
___CSS_LOADER_EXPORT___.push([module.id, `.Reviews_container__eXLyG {
  padding: 2rem 1rem;
  text-align: center;
  background-color: #fff;
  background: #dfd9d6;
  border-radius: 0.5rem;
  margin-top: 1rem;
  margin-bottom: 2rem;
}

.Reviews_title__SCEqY {
  font-size: 2rem;
  font-weight: 600;
  margin-bottom: 2rem;
  color: #2c2c2c;
}

.Reviews_sliderContainer__9Wbna {
  position: relative;
  display: flex;
  align-items: center;
  justify-content: center;
  padding: 0rem 1rem;
}

.Reviews_mySwiper__AApEj {
  width: 85%;
  padding: 0rem 0;
}

.Reviews_cardContainer__ckH-4 {
  display: flex;
  justify-content: center;
  align-items: stretch;
}

.Reviews_reviewCard__gUYex {
  background-color: #faf8f7;
  border-radius: 1rem;
  box-shadow: none;
  padding: 1rem;
  width: 100%;
  min-height: 250px;
  max-height: 250px;
  height: 100%;
  display: flex;
  flex-direction: column;
  justify-content: space-between;
  transition: transform 0.3s ease, box-shadow 0.3s ease;
}

.Reviews_reviewCard__gUYex:hover {
  transform: translateY(-5px);
  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);
}

.Reviews_usernameRating__Q2nGU {
  margin-bottom: 1rem;
}

.Reviews_username__DwTVd {
  font-weight: 600;
  font-size: 1.1rem;
  color: #1e1e1e;
  margin-top: 1rem;
}

.Reviews_description__NeiI9 {
  font-size: 0.9rem;
  color: #555;
  line-height: 1.6;
  text-align: left;
  flex-grow: 1;
  overflow: hidden;
  display: -webkit-box;
  -webkit-line-clamp: 6;
  -webkit-box-orient: vertical;
}

.Reviews_rating__RQAAY {
  margin-top: 0rem;
}

/* ----- Navigation Buttons ----- */
.Reviews_navButton__ThdeI {
  position: absolute;
  top: 50%;
  transform: translateY(-50%);
  z-index: 10;
  background-color: rgba(255, 255, 255, 0.9);
  color: #333;
  border-radius: 50%;
  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);
  transition: all 0.3s ease;
}

.Reviews_navButton__ThdeI:hover {
  background-color: #f1ede9;
  transform: translateY(-50%) scale(1.05);
}

.Reviews_prevButton__h4lKB {
  left: 0;
}

.Reviews_nextButton__697JS {
  right: 0;
}

/*  ----- Mobile View (below 770px) ----- */
.Reviews_mobileReviewList__9gMG1 {
  display: flex;
  flex-direction: column;
  align-items: center;
  gap: 1.2rem;
  padding: 0 1rem;
}

.Reviews_cardContainerMob__J1NbQ {
  width: 100%;
  max-width: 500px;
}

.Reviews_reviewCard__gUYex {
  background-color: #faf8f7;
  border-radius: 1rem;
  padding: 1.2rem;
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);
  text-align: left;
  width: 90%;
  max-height: 150px !important;
}

.Reviews_mobileUsername__cOOlG {
  font-weight: 600;
  font-size: 1rem;
  color: #1e1e1e;
  margin-bottom: 0.5rem;
}

.Reviews_mobileRating__6RZu0 {
  margin-top: 0.8rem;
  display: flex;
  justify-content: flex-start;
}

@media (max-width: 520px) {
  .Reviews_container__eXLyG {
    padding: 1.5rem 0.8rem;
  }

  .Reviews_title__SCEqY {
    font-size: 1.5rem;
    margin-bottom: 1.5rem;
  }

  .Reviews_reviewCard__gUYex {
    padding: 1rem;
      max-height: 150px;
  }

  .Reviews_description__NeiI9 {
    font-size: 0.9rem;
    text-align: justify;
    -webkit-line-clamp: 8; 
  }

  .Reviews_mobileUsername__cOOlG {
    font-size: 1rem;
  }

  .Reviews_mobileRating__6RZu0 {
    justify-content: center; 
  }
}
`, "",{"version":3,"sources":["webpack://./src/Components/Home/Reviews.module.css"],"names":[],"mappings":"AAAA;EACE,kBAAkB;EAClB,kBAAkB;EAClB,sBAAsB;EACtB,mBAAmB;EACnB,qBAAqB;EACrB,gBAAgB;EAChB,mBAAmB;AACrB;;AAEA;EACE,eAAe;EACf,gBAAgB;EAChB,mBAAmB;EACnB,cAAc;AAChB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,mBAAmB;EACnB,uBAAuB;EACvB,kBAAkB;AACpB;;AAEA;EACE,UAAU;EACV,eAAe;AACjB;;AAEA;EACE,aAAa;EACb,uBAAuB;EACvB,oBAAoB;AACtB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,gBAAgB;EAChB,aAAa;EACb,WAAW;EACX,iBAAiB;EACjB,iBAAiB;EACjB,YAAY;EACZ,aAAa;EACb,sBAAsB;EACtB,8BAA8B;EAC9B,qDAAqD;AACvD;;AAEA;EACE,2BAA2B;EAC3B,2CAA2C;AAC7C;;AAEA;EACE,mBAAmB;AACrB;;AAEA;EACE,gBAAgB;EAChB,iBAAiB;EACjB,cAAc;EACd,gBAAgB;AAClB;;AAEA;EACE,iBAAiB;EACjB,WAAW;EACX,gBAAgB;EAChB,gBAAgB;EAChB,YAAY;EACZ,gBAAgB;EAChB,oBAAoB;EACpB,qBAAqB;EACrB,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;AAClB;;AAEA,mCAAmC;AACnC;EACE,kBAAkB;EAClB,QAAQ;EACR,2BAA2B;EAC3B,WAAW;EACX,0CAA0C;EAC1C,WAAW;EACX,kBAAkB;EAClB,0CAA0C;EAC1C,yBAAyB;AAC3B;;AAEA;EACE,yBAAyB;EACzB,uCAAuC;AACzC;;AAEA;EACE,OAAO;AACT;;AAEA;EACE,QAAQ;AACV;;AAEA,2CAA2C;AAC3C;EACE,aAAa;EACb,sBAAsB;EACtB,mBAAmB;EACnB,WAAW;EACX,eAAe;AACjB;;AAEA;EACE,WAAW;EACX,gBAAgB;AAClB;;AAEA;EACE,yBAAyB;EACzB,mBAAmB;EACnB,eAAe;EACf,0CAA0C;EAC1C,gBAAgB;EAChB,UAAU;EACV,4BAA4B;AAC9B;;AAEA;EACE,gBAAgB;EAChB,eAAe;EACf,cAAc;EACd,qBAAqB;AACvB;;AAEA;EACE,kBAAkB;EAClB,aAAa;EACb,2BAA2B;AAC7B;;AAEA;EACE;IACE,sBAAsB;EACxB;;EAEA;IACE,iBAAiB;IACjB,qBAAqB;EACvB;;EAEA;IACE,aAAa;MACX,iBAAiB;EACrB;;EAEA;IACE,iBAAiB;IACjB,mBAAmB;IACnB,qBAAqB;EACvB;;EAEA;IACE,eAAe;EACjB;;EAEA;IACE,uBAAuB;EACzB;AACF","sourcesContent":[".container {\r\n  padding: 2rem 1rem;\r\n  text-align: center;\r\n  background-color: #fff;\r\n  background: #dfd9d6;\r\n  border-radius: 0.5rem;\r\n  margin-top: 1rem;\r\n  margin-bottom: 2rem;\r\n}\r\n\r\n.title {\r\n  font-size: 2rem;\r\n  font-weight: 600;\r\n  margin-bottom: 2rem;\r\n  color: #2c2c2c;\r\n}\r\n\r\n.sliderContainer {\r\n  position: relative;\r\n  display: flex;\r\n  align-items: center;\r\n  justify-content: center;\r\n  padding: 0rem 1rem;\r\n}\r\n\r\n.mySwiper {\r\n  width: 85%;\r\n  padding: 0rem 0;\r\n}\r\n\r\n.cardContainer {\r\n  display: flex;\r\n  justify-content: center;\r\n  align-items: stretch;\r\n}\r\n\r\n.reviewCard {\r\n  background-color: #faf8f7;\r\n  border-radius: 1rem;\r\n  box-shadow: none;\r\n  padding: 1rem;\r\n  width: 100%;\r\n  min-height: 250px;\r\n  max-height: 250px;\r\n  height: 100%;\r\n  display: flex;\r\n  flex-direction: column;\r\n  justify-content: space-between;\r\n  transition: transform 0.3s ease, box-shadow 0.3s ease;\r\n}\r\n\r\n.reviewCard:hover {\r\n  transform: translateY(-5px);\r\n  box-shadow: 0 10px 20px rgba(0, 0, 0, 0.12);\r\n}\r\n\r\n.usernameRating {\r\n  margin-bottom: 1rem;\r\n}\r\n\r\n.username {\r\n  font-weight: 600;\r\n  font-size: 1.1rem;\r\n  color: #1e1e1e;\r\n  margin-top: 1rem;\r\n}\r\n\r\n.description {\r\n  font-size: 0.9rem;\r\n  color: #555;\r\n  line-height: 1.6;\r\n  text-align: left;\r\n  flex-grow: 1;\r\n  overflow: hidden;\r\n  display: -webkit-box;\r\n  -webkit-line-clamp: 6;\r\n  -webkit-box-orient: vertical;\r\n}\r\n\r\n.rating {\r\n  margin-top: 0rem;\r\n}\r\n\r\n/* ----- Navigation Buttons ----- */\r\n.navButton {\r\n  position: absolute;\r\n  top: 50%;\r\n  transform: translateY(-50%);\r\n  z-index: 10;\r\n  background-color: rgba(255, 255, 255, 0.9);\r\n  color: #333;\r\n  border-radius: 50%;\r\n  box-shadow: 0 4px 10px rgba(0, 0, 0, 0.15);\r\n  transition: all 0.3s ease;\r\n}\r\n\r\n.navButton:hover {\r\n  background-color: #f1ede9;\r\n  transform: translateY(-50%) scale(1.05);\r\n}\r\n\r\n.prevButton {\r\n  left: 0;\r\n}\r\n\r\n.nextButton {\r\n  right: 0;\r\n}\r\n\r\n/*  ----- Mobile View (below 770px) ----- */\r\n.mobileReviewList {\r\n  display: flex;\r\n  flex-direction: column;\r\n  align-items: center;\r\n  gap: 1.2rem;\r\n  padding: 0 1rem;\r\n}\r\n\r\n.cardContainerMob {\r\n  width: 100%;\r\n  max-width: 500px;\r\n}\r\n\r\n.reviewCard {\r\n  background-color: #faf8f7;\r\n  border-radius: 1rem;\r\n  padding: 1.2rem;\r\n  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.05);\r\n  text-align: left;\r\n  width: 90%;\r\n  max-height: 150px !important;\r\n}\r\n\r\n.mobileUsername {\r\n  font-weight: 600;\r\n  font-size: 1rem;\r\n  color: #1e1e1e;\r\n  margin-bottom: 0.5rem;\r\n}\r\n\r\n.mobileRating {\r\n  margin-top: 0.8rem;\r\n  display: flex;\r\n  justify-content: flex-start;\r\n}\r\n\r\n@media (max-width: 520px) {\r\n  .container {\r\n    padding: 1.5rem 0.8rem;\r\n  }\r\n\r\n  .title {\r\n    font-size: 1.5rem;\r\n    margin-bottom: 1.5rem;\r\n  }\r\n\r\n  .reviewCard {\r\n    padding: 1rem;\r\n      max-height: 150px;\r\n  }\r\n\r\n  .description {\r\n    font-size: 0.9rem;\r\n    text-align: justify;\r\n    -webkit-line-clamp: 8; \r\n  }\r\n\r\n  .mobileUsername {\r\n    font-size: 1rem;\r\n  }\r\n\r\n  .mobileRating {\r\n    justify-content: center; \r\n  }\r\n}\r\n"],"sourceRoot":""}]);
// Exports
___CSS_LOADER_EXPORT___.locals = {
	"container": `Reviews_container__eXLyG`,
	"title": `Reviews_title__SCEqY`,
	"sliderContainer": `Reviews_sliderContainer__9Wbna`,
	"mySwiper": `Reviews_mySwiper__AApEj`,
	"cardContainer": `Reviews_cardContainer__ckH-4`,
	"reviewCard": `Reviews_reviewCard__gUYex`,
	"usernameRating": `Reviews_usernameRating__Q2nGU`,
	"username": `Reviews_username__DwTVd`,
	"description": `Reviews_description__NeiI9`,
	"rating": `Reviews_rating__RQAAY`,
	"navButton": `Reviews_navButton__ThdeI`,
	"prevButton": `Reviews_prevButton__h4lKB`,
	"nextButton": `Reviews_nextButton__697JS`,
	"mobileReviewList": `Reviews_mobileReviewList__9gMG1`,
	"cardContainerMob": `Reviews_cardContainerMob__J1NbQ`,
	"mobileUsername": `Reviews_mobileUsername__cOOlG`,
	"mobileRating": `Reviews_mobileRating__6RZu0`
};
export default ___CSS_LOADER_EXPORT___;
